import { Center } from '@/types/models'
import React from 'react'
import { Helmet } from 'react-helmet'

interface ElfsightReviewsDynamicWidgetInterface {
  (props: { center: Center }): JSX.Element
}

const ElfsightReviewsDynamicWidget: ElfsightReviewsDynamicWidgetInterface = ({
  center
}) => {
  return (
    <>
      <Helmet>
        <script
          src="https://static.elfsight.com/platform/platform.js"
          data-use-service-core
          defer
        />
      </Helmet>
      <div
        className="elfsight-app-bf82600d-b168-4fec-9d31-29c4cb6ee0b7"
        data-elfsight-app-lazy
        data-elfsight-app-source={center.googlePlaceID}
      />
    </>
  )
}

export default ElfsightReviewsDynamicWidget
